module.exports = __webpack_public_path__ + "img/cute_natural_doodle_3.db1fc371.png";